import React from "react";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ReadMoreIcon from "@mui/icons-material/ReadMore";

import { useDataTableContext } from "commons/context/dataTable";

import { LoadTableDataInterface } from "commons/types/table";

import { GridItem, GridRow } from "commons/ui/Grid";

type PropsType<T> = {
    readonly row: T;
    readonly onDowload?: (row: T) => void;
    readonly disableDownload?: boolean;
    readonly onDelete?: (row: T, loadTableData: LoadTableDataInterface) => void;
    readonly disableDelete?: boolean;
    readonly onEdit?: (row: T) => void;
    readonly disableEdit?: boolean;
    readonly onShowDetails?: (row: T) => void;
    readonly disableShowDetails?: boolean;
    readonly onDuplicate?: (row: T, loadTableData: LoadTableDataInterface) => void;
    readonly disableDuplicate?: boolean;
};

function ActionsTableCell<T>({
    row,
    onDowload,
    disableDownload,
    onDelete,
    disableDelete,
    onEdit,
    disableEdit,
    onShowDetails,
    disableShowDetails,
    onDuplicate,
    disableDuplicate,
}: PropsType<T>) {
    const { loadTableData } = useDataTableContext();

    const onDownloadAction = React.useCallback(() => {
        onDowload!(row);
    }, [onDowload, row]);

    const onDeleteAction = React.useCallback(() => {
        onDelete!(row, loadTableData);
    }, [onDelete, loadTableData, row]);

    const onEditAction = React.useCallback(() => {
        onEdit!(row);
    }, [onEdit, row]);

    const onShowDetailsAction = React.useCallback(() => {
        onShowDetails!(row);
    }, [onShowDetails, row]);

    const onDuplicateAction = React.useCallback(() => {
        onDuplicate!(row, loadTableData);
    }, [onDuplicate, loadTableData, row]);

    return (
        <GridRow justifyContent={"center"} className={"actions-table-cell"}>
            {onDowload && (
                <GridItem>
                    <FileDownloadIcon
                        className={`table-icon ${disableDownload ? "disabled" : ""}`}
                        onClick={onDownloadAction}
                        titleAccess={"Download"}
                    />
                </GridItem>
            )}

            {onEdit && (
                <GridItem>
                    <EditIcon
                        className={`table-icon ${disableEdit ? "disabled" : ""}`}
                        onClick={onEditAction}
                        titleAccess={"Modifica"}
                    />
                </GridItem>
            )}

            {onDuplicate && (
                <GridItem>
                    <ContentCopyIcon
                        className={`table-icon ${disableDuplicate ? "disabled" : ""}`}
                        onClick={onDuplicateAction}
                        titleAccess={"Duplica"}
                    />
                </GridItem>
            )}

            {onDelete && (
                <GridItem>
                    <DeleteIcon
                        className={`table-icon ${disableDelete ? "disabled" : ""}`}
                        onClick={onDeleteAction}
                        titleAccess={"Elimina"}
                    />
                </GridItem>
            )}

            {onShowDetails && (
                <GridItem>
                    <ReadMoreIcon
                        className={`table-icon ${disableShowDetails ? "disabled" : ""}`}
                        onClick={onShowDetailsAction}
                        titleAccess={"Mostra dettaglio"}
                    />
                </GridItem>
            )}
        </GridRow>
    );
}

export default ActionsTableCell;
